import { USE_MOCKS } from '../config/serviceConfig';
import { authMock } from './mock/auth.mock';
import { authReal } from './real/auth.real';
import type { IAuthService } from './interfaces/IAuthService';

export const authService: IAuthService = USE_MOCKS ? authMock : authReal;
